const url = 'http://127.0.0.1:8000'

export default url;